import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import { doLogout } from '../../actions';

const Header = (props) => {

    let current = [];
    if (props.page.page) {
      current = props.page.page.template;
    }

    return <header className="site-header">
          <nav className="navbar navbar-expand-lg navbar-light bg-white">
              <div className="container">
                  <Link to="/" className="navbar-brand"><img src="https://linkin.se/images/logo.svg" alt="Linkin logotyp" width="140"/></Link>



                  <div className="collapse navbar-collapse  d-print-none" id="navbarSupportedContent">
                      <ul className="navbar-nav mr-auto">
                          <li className={"nav-item " + (current == "events" ? "active" : "")}>
                            <Link to="/events" className="nav-link">Aktiviteter</Link>
                          </li>
                          <li className={"nav-item " + (current == "models" ? "active" : "")}>
                            <Link to="/models" className="nav-link" href="#">Modeller</Link>
                          </li>
                          <li className={"nav-item " + (current == "contracts" ? "active" : "")}>
                            <Link to="/contracts" className="nav-link">Kontrakt</Link>
                          </li>
                      </ul>
                      <ul className="navbar-nav">
                          <li className="nav-item">
                              <a className="btn btn-light" onClick={props.onLogoutClick}>Logga ut</a>
                          </li>
                      </ul>
                  </div>
              </div>
          </nav>
      </header>;
}

export default connect(
  state => {
      return {
          page: state.pageState
      }
  },

  (dispatch) => {
    return {
        onLogoutClick: (e) => {
            doLogout(dispatch);
        }
    }
  }
)(Header);
